import api from '@/api/client'
import { fetchAllPages } from './pagination'

/**
 * Progress service
 */

/**
 * Fetch progress list with optional query params.
 * @param {Record<string, any>} params
 */
export const fetchProgress = async (params = {}) => {
  if (!params.page) return fetchAllPages('progress/', params)
  const res = await api.get('progress/', { params })
  return res.data
}

/**
 * Update video progress for a lesson within an enrollment.
 * @param {number|string} cmsLessonId
 * @param {number} progressSeconds
 * @param {number} durationSeconds
 * @param {number} enrollmentId
 */
export const updateVideoProgress = async (cmsLessonId, progressSeconds, durationSeconds, enrollmentId) => {
  const res = await api.post('progress/update-video-progress/', {
    cms_lesson_id: cmsLessonId,
    progress_seconds: progressSeconds,
    duration_seconds: durationSeconds,
    enrollment_id: enrollmentId,
  })
  return res.data
}

/**
 * Patch an existing progress record by id.
 * @param {number} id
 * @param {object} data
 */
export const patchProgress = async (id, data) => {
  const res = await api.patch(`progress/${id}/`, data)
  return res.data
}

/**
 * Create a progress record.
 * @param {object} data
 */
export const createProgress = async (data) => {
  const res = await api.post('progress/', data)
  return res.data
}
